import Request from "../lib/request";
import {
  INIT_API,
  PROJECT_USERS_API,
  PROJECTS_API,
  UPDATE_CONNECT_TO_PARTNERS,
  UPDATE_TRANSACTION_DAY_LIMIT,
  UPDATE_USE_API_TOKEN,
  UPDATE_USE_IMPREST_SEQUENCE
} from "../constants/api";
import { PROJECT_ID, PROJECT_USER_ID } from "../constants/storageKeys";

const baseUrl = process.env.REACT_APP_API_URL;

export const init = () => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);

  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${INIT_API}`,
    needToken: true
  });
};

export const helpStatus = status => {
  return Request({
    method: "patch",
    url: baseUrl + "/changeHelpStatus",
    needToken: true,
    data: {
      help_status: status
    }
  });
};

export const updateUseImprestSequence = data => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${UPDATE_USE_IMPREST_SEQUENCE}`,
    needToken: true,
    data: data
  });
};
export const updateConnectWithApi = data => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${UPDATE_USE_API_TOKEN}`,
    needToken: true,
    data: data
  });
};
export const updateConnectToPartners = data => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${UPDATE_CONNECT_TO_PARTNERS}`,
    needToken: true,
    data: data
  });
};
export const updateTransactionDateLimit = data => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${UPDATE_TRANSACTION_DAY_LIMIT}`,
    needToken: true,
    data: data
  });
};
